import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
} from '@mui/material';
import { FileSelector } from '@components/file-selector.tsx';
import { useVersionUploader } from '@components/version-uploader/use-version-uploader.ts';
import { LoadingButton } from '@mui/lab';

interface ICombineZoneProps {
  onClose: () => void;
}

export const VersionUploader = (props: ICombineZoneProps) => {
  const { name, file, loading, onSuccess, onChangeName, onChangeFile } =
    useVersionUploader(props.onClose);
  return (
    <Dialog open={true} fullWidth maxWidth="xs">
      <DialogTitle>Cargar versión</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={1}>
          <Grid size={{ xs: 12 }}>
            <TextField
              autoFocus
              fullWidth
              value={name}
              autoComplete={'off'}
              label="Nombre de versión"
              variant="outlined"
              onChange={onChangeName}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FileSelector
              value={file}
              types={['geojson']}
              onChangeFile={onChangeFile}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={props.onClose} disabled={loading}>
          Cancelar
        </Button>
        <LoadingButton
          loading={loading}
          variant="contained"
          disabled={!file || name.length < 5}
          onClick={onSuccess}
        >
          Cargar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
